import { supabase } from "./supabase";
import * as Sentry from "@sentry/react";

const API_URL = import.meta.env.VITE_API_URL || "https://relay-backend-app.fly.dev";

async function refreshToken() {
  const { data, error } = await supabase.auth.refreshSession();
  if (error) throw error;
  return data.session?.access_token;
}

async function fetchWithRetry(url, options, token) {
  const headers = { ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  let res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    try {
      const newToken = await refreshToken();
      if (newToken) {
        headers["Authorization"] = `Bearer ${newToken}`;
        res = await fetch(url, { ...options, headers });
      }
    } catch {
      // refresh failed, return the 401 response
    }
  }

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const error = new Error(`API ${res.status}: ${text}`);
    Sentry.captureException(error, { extra: { url, status: res.status } });
    throw error;
  }
  return res.json();
}

export async function apiGet(path, token) {
  return fetchWithRetry(`${API_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
  }, token);
}

export async function apiPost(path, body, token) {
  return fetchWithRetry(`${API_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  }, token);
}

// Public GET (no auth token) — used for candidates/lookup before login
export async function apiGetPublic(path) {
  const url = `${API_URL}${path}`;
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const error = new Error(`API ${res.status}: ${text}`);
    Sentry.captureException(error, { extra: { url, status: res.status } });
    throw error;
  }
  return res.json();
}
